import * as actions from './formElement.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { FormElementModel } from '@smarttask-common/src/lib/models/Form/Element/FormElementModel';

export const elementAdapter = createEntityAdapter<FormElementModel>({
    selectId: (x) => x.element_id,
});
export interface FormElementState extends EntityState<FormElementModel> {
    selected_element_id: string;
}

export const initialState: FormElementState = elementAdapter.getInitialState({
    selected_element_id: undefined,
});

export function FormElementReducers(state: FormElementState = initialState, action: actions.FormElementActions) {
    switch (action.type) {
        case actions.FormElementActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_element_id: action.selected_element_id };
            //console.log(state);
            return state;

        case actions.FormElementActionTypes.ADD_FORM_ELEMENT:
            return elementAdapter.addOne(action.element, state);

        case actions.FormElementActionTypes.ADD_FORM_ELEMENTS:
            return elementAdapter.addMany(action.elements, state);

        case actions.FormElementActionTypes.UPSERT_FORM_ELEMENT:
            return elementAdapter.upsertOne(action.element, state);

        case actions.FormElementActionTypes.UPSERT_FORM_ELEMENTS:
            return elementAdapter.upsertMany(action.elements, state);

        case actions.FormElementActionTypes.UPDATE_FORM_ELEMENT:
            return elementAdapter.updateOne(action.element, state);

        case actions.FormElementActionTypes.UPDATE_FORM_ELEMENTS:
            return elementAdapter.updateMany(action.elements, state);

        case actions.FormElementActionTypes.DELETE_FORM_ELEMENT:
            // if(state.selectedFormElementId == action.id){
            //   state.selectedFormElementId = undefined;
            // }
            return elementAdapter.removeOne(action.id, state);

        case actions.FormElementActionTypes.DELETE_FORM_ELEMENTS:
            // if(action.ids.indexOf(state.selectedFormElementId) > -1){
            //   state.selectedFormElementId = undefined;
            // }
            return elementAdapter.removeMany(action.ids, state);

        case actions.FormElementActionTypes.DELETE_ALL_FORM_ELEMENTS:
            return elementAdapter.removeMany(action.ids, state);

        case actions.FormElementActionTypes.DELETE_ALL:
            return elementAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getFormElementState = createFeatureSelector<FormElementState>('formElement');

export const { selectIds, selectEntities, selectAll, selectTotal } = elementAdapter.getSelectors(getFormElementState);

const getSelectedFormElementIdState = (state: FormElementState) => {
    return state.selected_element_id;
};
export const getSelectedFormElementId = createSelector(getFormElementState, getSelectedFormElementIdState);

export const getSelectedFormElement = createSelector(getFormElementState, (state: FormElementState) => {
    if (state.selected_element_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_element_id];
});